export const isRangeDates = (dateFrom, dateTo, dateNow) => {
  return dateFrom && dateTo && dateNow > new Date(dateFrom.getFullYear(), dateFrom.getMonth(), dateFrom.getDate()) && dateNow < new Date(dateTo.getFullYear(), dateTo.getMonth(), dateTo.getDate());
};
